// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetMyRegistrationTypeRequestModel from '../../model/get-my-registration-type-request-model';
import GetMyRegistrationTypeRequestDTO from '../dto/get-my-registration-type-request-dto';
import dtoSchema from '../schemas/get-my-registration-type-request-schema';

export default abstract class GetMyRegistrationTypeRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetMyRegistrationTypeRequestDTO>) {
    super();
  }

  static toModel(dto: DeepPartial<GetMyRegistrationTypeRequestDTO>): GetMyRegistrationTypeRequestModel;
  static toModel(dto: DeepPartial<GetMyRegistrationTypeRequestDTO> | undefined | null): GetMyRegistrationTypeRequestModel | undefined;
  static toModel(dto: DeepPartial<GetMyRegistrationTypeRequestDTO> | undefined | null): GetMyRegistrationTypeRequestModel | undefined {
    return dto ? new GetMyRegistrationTypeRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetMyRegistrationTypeRequestModel> | GetMyRegistrationTypeRequestModel): GetMyRegistrationTypeRequestDTO {
    const dto = {
    } as GetMyRegistrationTypeRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetMyRegistrationTypeRequestModel, can not map to GetMyRegistrationTypeRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
